import { FormElement } from './form-element.model';

export class FormElementIntegerInput extends FormElement {
  public constructor() {
    super();

    this.intialize();
  }

  public intialize = (): void => {
    this.Value = 0;
    this.ElementTypeId = 5;
  };

  public Value: number;
}
